const ArrowRight = () => {
  return (
    <svg viewBox="0 0 32 32">
      <path d="M26.0002 14.9999H8.4142L13.7072 9.70687C13.9598 9.45428 14.0584 9.08613 13.966 8.74109C13.8735 8.39605 13.604 8.12654 13.259 8.03409C12.9139 7.94164 12.5458 8.04028 12.2932 8.29287L5.2932 15.2929C5.10548 15.4803 5 15.7346 5 15.9999C5 16.2651 5.10548 16.5195 5.2932 16.7069L12.2932 23.7069C12.4803 23.8951 12.7348 24.0009 13.0002 24.0009C13.2656 24.0009 13.5201 23.8951 13.7072 23.7069C13.8949 23.5195 14.0004 23.2651 14.0004 22.9999C14.0004 22.7346 13.8949 22.4803 13.7072 22.2929L8.4142 16.9999H26.0002C26.5525 16.9999 27.0002 16.5522 27.0002 15.9999C27.0002 15.4476 26.5525 14.9999 26.0002 14.9999Z" />
    </svg>
  )
}

export default ArrowRight
